import React from 'react';
import ReactDOM from 'react-dom';
import App from './apps/app/app';
import './index.css';
import * as serviceWorker from './serviceWorker';
import i18n from './utils/i18n/i18n.util';

ReactDOM.render(<App />, document.getElementById('root'));

// Adjust the html tag's lang-attribute accordingly
if (document && document.documentElement) {
  i18n.on('languageChanged', (lng) => {
    document.documentElement.setAttribute('lang', lng);
  });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
